import styles from "@/solution/[id]/page.module.css";
import DynamicIconMapping from "@/Components/DynamicIconMapping";
import Image from "next/image";
import Link from "next/link";
import {
    getWebsiteProductBadges,
    getWebsiteProductImageFitMode,
    getWebsiteProductImageUrl,
    getWebsiteProductSummaryHtml,
} from "@/lib/product-presentation";

export default function SolutionProducts({products = []}) {
    return (
        <div className={styles.productsGrid}>
            {products.map((product) => {
                const badges = getWebsiteProductBadges(product);
                const summary = getWebsiteProductSummaryHtml(product);
                const thumbnail = getWebsiteProductImageUrl(product);
                const imageFitMode = getWebsiteProductImageFitMode(product);
                const imageClassName = [
                    styles.cardImage,
                    imageFitMode === "wide" ? styles.cardImageWide : "",
                    imageFitMode === "square" ? styles.cardImageSquare : "",
                    imageFitMode === "tall" ? styles.cardImageTall : "",
                ].filter(Boolean).join(" ");

                return (
                    <article key={product.id} className={styles.card}>
                        <div className={styles.cardBadges}>
                            {badges.map((badge, index) => (
                                <span
                                    key={`badge-${index}`}
                                    className={styles.dynamicIconMappingWrapper}
                                    title={`${badge.title}: ${badge.description}`}
                                    aria-label={`${badge.title}: ${badge.description}`}
                                    tabIndex={0}
                                >
                                    <DynamicIconMapping
                                        classString={badge.icon}
                                        size={19}
                                        aria-hidden="true"
                                    />
                                </span>
                            ))}
                        </div>
                        <div className={styles.cardIcons} aria-hidden="true">
                            <i className="fas fa-check-circle" />
                            <i className="fas fa-info-circle" />
                            <i className="fas fa-cogs" />
                            <i className="fas fa-share-alt" />
                        </div>
                        <Link href={`/product/${product.alt_id}`} className={styles.cardMediaLink}>
                            <div className={styles.cardMediaFrame}>
                                <Image
                                    src={thumbnail}
                                    alt={product.name}
                                    fill
                                    className={imageClassName}
                                    sizes="(max-width: 768px) 100vw, 300px"
                                />
                            </div>
                        </Link>
                        <h3 className={styles.cardTitle}>
                            <Link href={`/product/${product.alt_id}`} className={styles.cardTitleLink}>
                                {product.name}
                            </Link>
                        </h3>
                        <div
                            className={styles.cardText}
                            dangerouslySetInnerHTML={{__html: summary}}
                        />
                        <Link href={`/product/${product.alt_id}`} className="btn btn-primary w-100">
                            Read More about <br/><b>{product.name}</b>
                        </Link>
                    </article>
                );
            })}
        </div>
    )
}
